import React from 'react'
import { motion } from 'framer-motion'
import { ShieldCheck, LockKeyhole, BadgeCheck } from 'lucide-react'
import { useT } from '@/context/TranslateCtx'

export default function Security() {
  const { t } = useT()
  const cards = [
    { icon: <LockKeyhole size={36} strokeWidth={2} />, title: t('security.card1.title'), desc: t('security.card1.desc') },
    { icon: <ShieldCheck size={36} strokeWidth={2} />, title: t('security.card2.title'), desc: t('security.card2.desc') },
    { icon: <BadgeCheck size={36} strokeWidth={2} />, title: t('security.card3.title'), desc: t('security.card3.desc') },
  ]
  return (
    <section id="security" className="relative overflow-hidden py-24 bg-gradient-to-br from-primary/10 via-white to-info/10">
      <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-gray-100 to-transparent pointer-events-none" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-40 -left-20 w-96 h-96 bg-primary opacity-20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] bg-secondary opacity-20 rounded-full blur-3xl animate-pulse" />
      </div>
      <div className="container">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-center text-primary mb-16"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {t('security.heading')}
        </motion.h2>
        <div className="grid gap-10 md:grid-cols-3">
          {cards.map((c, i) => (
            <motion.div
              key={i}
              className="group bg-white/80 backdrop-blur-md p-8 rounded-3xl shadow-xl hover:shadow-2xl border border-gray-100"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
            >
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-primary/10 text-primary mb-6 group-hover:scale-110 transition-transform">
                {c.icon}
              </div>
              <h3 className="text-xl md:text-2xl font-semibold mb-2">{c.title}</h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">{c.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-gray-100 to-transparent pointer-events-none" />
    </section>
  )
}
